import Vue from 'vue'
import exoDatetimePicker from '@/components/Forms/dateTimePicker.vue'
import dataTools from '../../tools/data.js'
import dashboardTools from '../../tools/dashboard.js'
import componentTools from '../../tools/components.js'
import { mapActions, mapGetters } from 'vuex'
import tooltipApiDocumentation from '../../components/Tooltips/ApiScriptingOption/tooltipApiDocumentation'
/* eslint-disable vue/no-dupe-keys */

export default () => {
  Vue.component('exo-input-name', {
    props: {
      root: Object,
      alignWithParametricField: {
        type: Boolean,
        default: false
      }
    },
    template: `
      <v-row no-gutters>
        <v-col>
          <v-text-field
            id="inputName"
            :label="root.getFormLabel('name') + ' *'"
            v-model="root.inputs.name"
            maxlength="100"
            :rules="[root.inputNameFeedback]"
              >
          </v-text-field>
         </v-col>
          <v-col cols="1">
          <slot></slot>
          </v-col>
          <v-col v-if="alignWithParametricField" cols="2"/>

        
         </v-col>
      </v-row>

    `
  })

  Vue.component('exo-input-select', {
    props: {
      root: Object,
      parentObject: {
        type: Object,
        default: null
      },
      alignWithParametricField: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: String,
        default: null
      },
      disabledItemConfiguration: {
        type: String,
        default: ''
      },
      onChangeCallback: {
        type: Function,
        default: function () {
          //yes, keep empty
        }
      },
      items: {
        type: Array,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      name: String
    },

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },

      getItems() {
        if (this.items != null) {
          return this.items
        } else {
          return this.root.enumPropertiesList[this.name]
        }
      },

      isDisabledOnEdit() {
        return this.name === 'type' && this.root.inputs.editing
      },

      nbCols() {
        return componentTools.nbCols(this)
      }
    },

    template: `
        <v-row no-gutters v-if="root.isRequiredOrOptional(name, getParentObject)">
        <v-col>
          <v-tooltip right :disabled="!(tooltip !== '' && tooltip != null)" nudge-top="20">
            <template v-slot:activator="{ on }">
                <v-row no-gutters v-on="on">
                <v-col :cols="nbCols" >
                <v-select
                v-on:keyup.enter="$event.stopPropagation()"
                :multiple="multiple"
                v-on:change="onChangeCallback"
                :items="getItems"
                :label="root.getFormLabel(name)"
                :item-disabled="disabledItemConfiguration"
                v-model="getParentObject[name]"
                :disabled="isDisabledOnEdit || disabled"
                :rules="[root.getFieldState(getParentObject, name).message]"
                :menu-props="{transition:'scale-transition'}"
                ></v-select>
                </v-col>
                <v-col cols="1">
                <slot></slot>
                </v-col>
                <v-col v-if="alignWithParametricField" cols="2"></v-col>
                </v-row>
            </template>
            <span>{{tooltip}}</span>
          </v-tooltip>
          </v-col>
        
        </v-row>
  `
  })

  Vue.component('exo-input-checkbox', {
    props: {
      root: Object,
      parentObject: {
        type: Object,
        default: null
      },
      forceDisplay: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      customLabel: {
        type: String,
        default: null
      },
      name: String,
      tooltip: String,
      onChange: {
        type: Function,
        default: () => {
          //yes, keep empty
        }
      },
      alignWithParametricField: {
        type: Boolean,
        default: false
      },
      trueValue: {
        default: true
      },
      falseValue: {
        default: false
      }
    },

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      getLabel() {
        if (this.customLabel) {
          return this.customLabel
        }
        return this.root.getFormLabel(this.name)
      },

      nbCols() {
        return componentTools.nbCols(this)
      }
    },

    template: `
          <v-row align="center" no-gutters v-if="root.isRequiredOrOptional(name, getParentObject) || forceDisplay">
          <v-col>
            <v-tooltip right :disabled="!(tooltip !== '' && tooltip != null)">
              <template v-slot:activator="{ on }">
              <v-row no-gutters>
              <v-col :cols="nbCols">
                <v-checkbox
                  :disabled="disabled"
                  v-on="on"
                  class="mt-0 mb-0" 
                  v-model="getParentObject[name]"
                  :label="getLabel"
                  v-on:change="onChange()"
                  :true-value="trueValue"
                  :false-value="falseValue"
                ></v-checkbox>
                </v-col>
                <v-col cols="1">
                  <slot></slot>
                </v-col>
                <v-col v-if="alignWithParametricField" cols="2"/>
                </v-row> 
              </template>
              <span>{{tooltip}}</span>
            </v-tooltip>
          </v-col>
        </v-row>
  `
  })

  Vue.component('exo-form', {
    props: {
      root: Object,
      clear: {
        type: Boolean,
        default: true
      },
      hideClose: {
        type: Boolean,
        default: false
      },
      hideAPIButton: {
        type: Boolean,
        default: false
      },
      height100: {
        type: Boolean,
        default: false
      },
      beta: {
        type: Boolean,
        default: false
      }
    },
    components: {
      tooltipApiDocumentation
    },
    data() {
      return {
        listOfFieldInAdditionalImplication: new Set(),
        listOfValuesInAdditionalImplication: new Set(),
        listOfAdditionalRequirements: new Map(),
        additionalImplications: new Map(),
        listOfFieldsInEnumeratedField: new Set(),
        listOfEnumFieldsFromGeneralProperties: new Set(),
        enumeratedFieldInEnumeratedField: false
      }
    },

    computed: {
      ...mapGetters({ currentUser: 'currentUser' }),
      backgroundStarStyle() {
        return 'background: #3BE287'
      },
      backgroundDescriptionStyle() {
        return ' background-color: rgba(255, 255, 255, 0.1);'
      }
    },

    methods: {
      validate() {
        if (this.root.inputsValid) {
          this.root.submitForm()
        }
      },
      closeForm() {
        delete localStorage.history
        this.root.inputs.displayForm = false
      },
      scriptingOptionActivated() {
        return (
          this?.currentUser?.options != null &&
          this.currentUser.options.includes('SCRIPTING')
        )
      },
      generateAPIScript(completeObject, spacing) {
        let apiScript = ''
        const propertiesToGenerate = Object.entries(completeObject).filter(
          (entry) => {
            const name = entry[0]
            const value = entry[1]
            return this.isPropertyNeeded(name) && !this.isPropertyNull(value)
          }
        )

        for (const [propertyName, propertyValue] of propertiesToGenerate) {
          let value = ''
          if (Array.isArray(propertyValue)) {
            value = '[\n'
            for (const item of propertyValue) {
              value +=
                spacing +
                '\t' +
                this.generateValueText(item, spacing + '\t') +
                ', \n'
            }
            value += spacing + ']'
          } else {
            value = this.generateValueText(propertyValue, spacing)
          }
          apiScript =
            apiScript + spacing + "'" + propertyName + "' : " + value + ', \n'
        }
        return '{ \n' + apiScript + '}'
      },
      generateValueText(propertyValue, spacing) {
        if (dataTools.isNumber(propertyValue)) {
          return Number(propertyValue)
        } else if (propertyValue === true) {
          return 'True'
        } else if (propertyValue === false) {
          return 'False'
        } else if (
          typeof propertyValue === 'object' &&
          !Array.isArray(propertyValue) &&
          propertyValue != null
        ) {
          return (
            '{ \n' +
            spacing +
            '\t' +
            "'id' : '" +
            propertyValue['id'] +
            "'\n" +
            spacing +
            ' }'
          )
        } else {
          return "'" + propertyValue + "'"
        }
      },
      isPropertyNull(propertyValue) {
        return (
          propertyValue === '' ||
          propertyValue === 'NaN' ||
          propertyValue == null
        )
      },
      isPropertyNeeded(propertyName) {
        if (
          propertyName === 'parametricValues' ||
          propertyName === 'parametricReferences' ||
          propertyName === 'dirty' ||
          propertyName === 'updatedAt' ||
          propertyName === 'archived' ||
          propertyName === 'expired' ||
          propertyName === 'dataVersion' ||
          propertyName === 'typeName' ||
          propertyName === 'displayedName' ||
          propertyName === 'scriptConfig' ||
          propertyName === 'id'
        ) {
          return false
        }

        const allProperties = this.root
          .getAllPropertiesList(this.root.inputs)
          .concat('name')

        return allProperties.includes(propertyName)
      },
      getPropertiesList(requiredOrOptional) {
        if (requiredOrOptional === 'required') {
          const nameProperty = ['name']
          const allRequiredProperties = this.root.getCurrentFormDescription()
            .required
            ? this.root.getCurrentFormDescription().required
            : []
          return nameProperty.concat(allRequiredProperties)
        }
        const allOptionalProperties = this.root.getCurrentFormDescription()
          .optional
          ? this.root.getCurrentFormDescription().optional
          : []
        return allOptionalProperties
      },
      getAllProperties() {
        return [
          ...new Set(
            this.getPropertiesList('required').concat(
              this.getPropertiesList('optional')
            )
          )
        ]
      },
      getSpecificField(fieldName) {
        return this.root.getCurrentFormDescription().properties[fieldName]
      },
      getNameAndLabel(fieldName) {
        if (this.getSpecificField(fieldName)) {
          const label = this.getSpecificField(fieldName).label
          return label != null ? fieldName + ' (' + label + ')' : '-'
        }
        return '-'
      },
      getType(fieldName) {
        if (this.getSpecificField(fieldName) != null) {
          const type = this.getSpecificField(fieldName).type
          return type != null ? type : '-'
        }
        return '-'
      },
      getMin(fieldName) {
        if (this.getSpecificField(fieldName) != null) {
          const valueExclusive = this.getSpecificField(fieldName).minExclusive
          const valueInclusive = this.getSpecificField(fieldName).minInclusive
          if (valueExclusive != null) {
            let min = this.convertStringToNumber(valueExclusive)
            return min + ' (exclusive)'
          } else if (valueInclusive != null) {
            let min = this.convertStringToNumber(valueInclusive)
            return min + ' (inclusive)'
          }
        }
        return '-'
      },
      getMax(fieldName) {
        if (this.getSpecificField(fieldName) != null) {
          const valueExclusive = this.getSpecificField(fieldName).maxExclusive
          const valueInclusive = this.getSpecificField(fieldName).maxInclusive
          if (valueExclusive != null) {
            let max = this.convertStringToNumber(valueExclusive)
            return max + ' (exclusive)'
          } else if (valueInclusive != null) {
            let max = this.convertStringToNumber(valueInclusive)
            return max + ' (inclusive)'
          }
        }
        return '-'
      },
      getExcludedValues(fieldName) {
        if (this.getSpecificField(fieldName) != null) {
          let value = this.getSpecificField(fieldName).excludeValues
          if (value != null) {
            value = this.convertStringToNumber(value)
            return value
          }
        }
        return '-'
      },
      getDefaultValue(fieldName) {
        if (this.getSpecificField(fieldName) != null) {
          let value = this.getSpecificField(fieldName)?.defaultValue
          if (value != null && value !== '') {
            value = this.convertStringToNumber(value)
            return value
          }
        }
        return '-'
      },
      getUnit(fieldName) {
        const type = this.getType(fieldName)
        const unit = dataTools.getSiUnit(type)
        return unit !== '' ? unit : '-'
      },
      isOneOf() {
        return (
          this.root.getCurrentFormDescription().oneOf != null &&
          this.root.getCurrentFormDescription().oneOf.type != null
        )
      },
      convertStringToNumber(value) {
        if (typeof value === 'string') {
          if (value.includes('PI')) {
            let previousChar = value.split('PI')[0].slice(-1)
            let nextChar = value.split('PI')[1].slice(0)
            let returnValue = value
            if (
              dataTools.isNumber(parseFloat(previousChar)) &&
              !dataTools.isNumber(parseFloat(nextChar))
            ) {
              returnValue = value.replace('PI', '*Math.PI')
            } else if (
              !dataTools.isNumber(parseFloat(previousChar)) &&
              dataTools.isNumber(parseFloat(nextChar))
            ) {
              returnValue = value.replace('PI', 'Math.PI*')
            } else if (
              dataTools.isNumber(parseFloat(previousChar)) &&
              dataTools.isNumber(parseFloat(nextChar))
            ) {
              returnValue = value.replace('PI', '*Math.PI*')
            } else {
              returnValue = value.replace('PI', 'Math.PI')
            }
            return eval(returnValue)
          }
        }
        return value
      },
      numberOfColumns() {
        let numberOfColumns = 1
        if (!this.isOneOf()) {
          return numberOfColumns + 1
        }
        for (let item in this.getListOfTypes()) {
          numberOfColumns++
        }
        return numberOfColumns
      },
      getListOfTypes() {
        return this.root.getCurrentFormDescription().oneOf.type != null
          ? this.root.getCurrentFormDescription().oneOf.type
          : this.root.getCurrentFormDescription().oneOf
      },
      getItemList() {
        let itemList = []
        for (let item in this.getListOfTypes()) {
          itemList.push(item)
        }
        return itemList
      },
      additionalRequirements(fieldName) {
        if (!this.listOfAdditionalRequirements.has(fieldName)) {
          for (const [key, value] of Object.entries(this.getListOfTypes())) {
            if (key === fieldName) {
              const setRequired = new Set(value.required)
              const setOptional = new Set(value.optional)
              let setAllOptions = new Set([...setRequired, ...setOptional])
              this.listOfAdditionalRequirements.set(key, [...setAllOptions])

              if (value.oneOf != null) {
                for (const [key1, value1] of Object.entries(value.oneOf)) {
                  for (const [key2, value2] of Object.entries(value1)) {
                    if (value2.required) {
                      this.listOfFieldsInEnumeratedField = new Set([
                        ...this.listOfFieldsInEnumeratedField,
                        ...value2.required
                      ])
                    }
                    if (value2.optional) {
                      this.listOfFieldsInEnumeratedField = new Set([
                        ...this.listOfFieldsInEnumeratedField,
                        ...value2.optional
                      ])
                    }
                  }
                }
              }
            }
          }
        }
        return Array.from(this.listOfAdditionalRequirements.get(fieldName))
      },
      getGeneralImplications(fieldName, enumValues) {
        let implications = ''
        if (
          fieldName != 'type' &&
          this.root.getCurrentFormDescription().oneOf != null
        ) {
          for (const entry of enumValues) {
            for (const [key, value] of Object.entries(this.getListOfTypes())) {
              if (key === fieldName) {
                for (const [key1, value1] of Object.entries(value)) {
                  if (
                    key1 === entry &&
                    value1.required &&
                    value1.required?.length > 0
                  ) {
                    implications +=
                      "If '" +
                      key1 +
                      "' selected, then [" +
                      value1.required +
                      '] required \n'
                    this.enumeratedFieldInEnumeratedField = true
                    for (let field of value1.required) {
                      this.listOfEnumFieldsFromGeneralProperties.add(field)
                    }
                  }
                  if (
                    key1 === entry &&
                    value1.optional &&
                    value1.optional?.length > 0
                  ) {
                    implications +=
                      "If '" +
                      key1 +
                      "' selected, then [" +
                      value1.optional +
                      '] optional \n'
                    this.enumeratedFieldInEnumeratedField = true
                    for (let field of value1.optional) {
                      this.listOfEnumFieldsFromGeneralProperties.add(field)
                    }
                  }
                  if (value1.oneOf) {
                    for (const [key2, value2] of Object.entries(value1.oneOf)) {
                      for (const [key3, value3] of Object.entries(value2)) {
                        if (
                          !this.listOfFieldInAdditionalImplication.has(key3)
                        ) {
                          this.listOfFieldInAdditionalImplication.add(key3)

                          if (value3.required && value3.required?.length > 0) {
                            let initialValue = ''
                            if (this.additionalImplications.has(key2)) {
                              initialValue =
                                this.additionalImplications.get(key2) + '\n'
                            }
                            this.additionalImplications.set(
                              key2,
                              initialValue +
                                "If '" +
                                key3 +
                                "' selected, then [" +
                                value3.required +
                                '] required'
                            )
                            this.listOfValuesInAdditionalImplication = new Set([
                              ...this.listOfValuesInAdditionalImplication,
                              ...value3.required
                            ])
                          }
                          if (value3.optional && value3.optional?.length > 0) {
                            this.listOfFieldInAdditionalImplication.add(key3)
                            let initialValue = ''
                            if (this.additionalImplications.has(key2)) {
                              initialValue =
                                this.additionalImplications.get(key2) + '\n'
                            }
                            this.additionalImplications.set(
                              key2,
                              initialValue +
                                "If '" +
                                key3 +
                                "' selected, then [" +
                                value3.optional +
                                '] optional'
                            )
                            this.listOfValuesInAdditionalImplication = new Set([
                              ...this.listOfValuesInAdditionalImplication,
                              ...value3.optional
                            ])
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return implications
      },
      getImplications(fieldName, entry) {
        let implications = ''
        if (fieldName != 'type') {
          for (const [key, value] of Object.entries(this.getListOfTypes())) {
            if (key === fieldName) {
              if (value.oneOf != null) {
                for (const [key1, value1] of Object.entries(value.oneOf)) {
                  for (const [key2, value2] of Object.entries(value1)) {
                    if (
                      key1 === entry &&
                      value2.required &&
                      value2.required?.length > 0
                    ) {
                      implications +=
                        "If '" +
                        key2 +
                        "' selected, then [" +
                        value2.required +
                        '] required \n'
                    }
                    if (
                      key1 === entry &&
                      value2.optional &&
                      value2.optional?.length > 0
                    ) {
                      implications +=
                        "If '" +
                        key2 +
                        "' selected, then [" +
                        value2.optional +
                        '] optional \n'
                    }
                    if (value2.oneOf) {
                      for (const [key3, value3] of Object.entries(
                        value2.oneOf
                      )) {
                        for (const [key4, value4] of Object.entries(value3)) {
                          if (
                            !this.listOfFieldInAdditionalImplication.has(key4)
                          ) {
                            if (
                              value4.required &&
                              value4.required?.length > 0
                            ) {
                              this.listOfFieldInAdditionalImplication.add(key4)
                              let initialValue = ''
                              if (this.additionalImplications.has(key3)) {
                                initialValue =
                                  this.additionalImplications.get(key3) + '\n'
                              }
                              this.additionalImplications.set(
                                key3,
                                initialValue +
                                  "If '" +
                                  key4 +
                                  "' selected, then [" +
                                  value4.required +
                                  '] required'
                              )
                              this.listOfValuesInAdditionalImplication =
                                new Set([
                                  ...this.listOfValuesInAdditionalImplication,
                                  ...value4.required
                                ])
                            }
                            if (
                              value4.optional &&
                              value4.optional?.length > 0
                            ) {
                              this.listOfFieldInAdditionalImplication.add(key4)
                              let initialValue = ''
                              if (this.additionalImplications.has(key3)) {
                                initialValue =
                                  this.additionalImplications.get(key3) + '\n'
                              }
                              this.additionalImplications.set(
                                key3,
                                initialValue +
                                  "If '" +
                                  key4 +
                                  "' selected, then [" +
                                  value4.optional +
                                  '] optional'
                              )
                              this.listOfValuesInAdditionalImplication =
                                new Set([
                                  ...this.listOfValuesInAdditionalImplication,
                                  ...value4.optional
                                ])
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return implications
      },
      getAdditionalImplications(entry) {
        if (this.additionalImplications.has(entry)) {
          return this.additionalImplications.get(entry)
        }
        return ''
      },
      getListOfFieldsInEnumeratedField() {
        const allAdditionalFieldNames = new Set(
          [].concat.apply([], [...this.listOfAdditionalRequirements.values()])
        )
        for (let fieldName of allAdditionalFieldNames.values()) {
          if (this.listOfFieldsInEnumeratedField.has(fieldName)) {
            this.listOfFieldsInEnumeratedField.delete(fieldName)
          }
        }
        const allEnumeratedFieldNames = new Set([
          ...this.listOfEnumFieldsFromGeneralProperties,
          ...this.listOfFieldsInEnumeratedField.values()
        ])
        for (let fieldName of allEnumeratedFieldNames) {
          if (this.getType(fieldName) === 'enum') {
            this.enumeratedFieldInEnumeratedField = true
          }
        }
        return Array.from(this.listOfEnumFieldsFromGeneralProperties).concat(
          Array.from(this.listOfFieldsInEnumeratedField).concat(
            Array.from(this.listOfValuesInAdditionalImplication)
          )
        )
      },

      tableTitleOneOf(objectType) {
        if (dashboardTools.isMissionType(objectType)) {
          return (
            'Additional required and optional fields properties for ' +
            objectType
          )
        }
        return (
          'Additional required and optional fields properties for ' +
          objectType +
          ' ' +
          this.root.getCurrentFormTitle()
        )
      },
      enumTypesObjects(propertiesList) {
        for (let item of propertiesList) {
          if (this.getType(item) === 'enum') {
            return true
          }
        }
        return false
      },
      getPossibleEnumValues(enumField) {
        let listOfEnumValues = []
        if (this.getType(enumField) === 'enum') {
          for (const [key, val] of Object.entries(
            this.root.getCurrentFormDescription().properties[enumField].values
          )) {
            if (val.value) {
              listOfEnumValues.push(val.value)
            }
          }
        }
        return listOfEnumValues.join(', ')
      },
      getEnumValues(enumField) {
        let listOfEnumValues = []
        if (this.getType(enumField) === 'enum') {
          for (const [key, val] of Object.entries(
            this.root.getCurrentFormDescription().properties[enumField].values
          )) {
            if (val.value) {
              listOfEnumValues.push(val.value)
            }
          }
        }
        return listOfEnumValues
      },
      oneOfAdditionalRequiredOrOptionalField(i, requiredOrOptional) {
        let oneOfListRequiredOrOptional = []
        for (const [key, val] of Object.entries(this.getListOfTypes())) {
          if (i === key) {
            if (requiredOrOptional === 'required' && val.required) {
              oneOfListRequiredOrOptional.push(val.required)
            } else if (requiredOrOptional === 'optional' && val.optional) {
              oneOfListRequiredOrOptional.push(val.optional)
            }
          }
        }
        return [].concat.apply([], oneOfListRequiredOrOptional).join(', ')
      },

      isColumnEmpty(columnToCheck, fieldsToCheck) {
        if (fieldsToCheck.length != null || fieldsToCheck.length === 0) {
          if (columnToCheck === 'min') {
            for (let i = 0; i < fieldsToCheck.length; i++) {
              if (
                (this.getSpecificField(fieldsToCheck[i]) != null &&
                  this.getSpecificField(fieldsToCheck[i])?.minExclusive !=
                    null) ||
                this.getSpecificField(fieldsToCheck[i])?.minInclusive != null
              ) {
                return false
              }
            }
            return true
          }
          if (columnToCheck === 'max') {
            for (let i = 0; i < fieldsToCheck.length; i++) {
              if (
                (this.getSpecificField(fieldsToCheck[i]) != null &&
                  this.getSpecificField(fieldsToCheck[i])?.maxExclusive !=
                    null) ||
                this.getSpecificField(fieldsToCheck[i])?.maxInclusive != null
              ) {
                return false
              }
            }
            return true
          }
          if (columnToCheck === 'excluded') {
            for (let i = 0; i < fieldsToCheck.length; i++) {
              if (
                this.getSpecificField(fieldsToCheck[i]) != null &&
                this.getSpecificField(fieldsToCheck[i])?.excludeValues !=
                  null &&
                this.getSpecificField(fieldsToCheck[i])?.excludeValues !== ''
              ) {
                return false
              }
            }
            return true
          }
          if (columnToCheck === 'default') {
            for (let i = 0; i < fieldsToCheck.length; i++) {
              if (
                this.getSpecificField(fieldsToCheck[i]) != null &&
                this.getSpecificField(fieldsToCheck[i])?.defaultValue != null &&
                this.getSpecificField(fieldsToCheck[i])?.defaultValue !== ''
              ) {
                return false
              }
            }
            return true
          }
          if (columnToCheck === 'unit') {
            for (let i = 0; i < fieldsToCheck.length; i++) {
              if (this.root.getDefaultUnitLabel(fieldsToCheck[i]) !== '') {
                return false
              }
            }
            return true
          }
        }
        return true
      },
      isButtonEnabled(condition) {
        if (condition) {
          return 'primary'
        } else return 'grey'
      }
    },
    template: `
  <v-card bg-white>
    <v-card-title :style="backgroundStarStyle">
      <span class="headline black--text">
        Edit {{root.getCurrentFormTitle()}}
        <sup v-if="beta" class="orange--text"
          >BETA</sup
        >
      </span>
      <slot name="titleTooltip"></slot>
      <v-text-field class="ml-2 ma-0 descriptionPlaceholder"
      solo
      flat
      hide-details
      light
      :style="backgroundDescriptionStyle"
      placeholder="Enter description"
      v-model="root.inputs.description"
      ></v-text-field>
      <v-btn v-if="!hideClose" icon light class="m-0" @click="closeForm()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form class="mx-auto pa-4" id="form-wrapper" :style="height100 ? 'height:100%' : ''" @keyup.native.enter="validate">
          <slot></slot> <!-- the fields -->
      </v-form>
      <v-card-actions class="mx-0">
     </v-card-actions>
    </v-card-text>
    <v-divider class="m-0"></v-divider>
    <v-card-actions class="mx-4">
      <v-btn :disabled="!root.inputsValid" @click="root.submitForm" id="submitBtn" :color="isButtonEnabled(root.inputsValid)" :loading="root.inputs.saving">{{root.submitAction}}</v-btn>
      <v-btn :disabled="root.inputs.saving" v-if="clear" @click="root.clearForm()" type="button" id="clearBtn" color="red lighten-2" dark text outlined >Clear</v-btn>
      <exo-api-button :disabled="!root.inputsValid" buttonName="API script template" title="API script " v-if="scriptingOptionActivated() && !hideAPIButton" class="mr-2 ml-2">
      <div style="white-space:pre"
      >{{generateAPIScript(root.createObjectFromForm(), '\t')}}
      </div>
     </exo-api-button>
     
    <exo-api-button buttonName="API documentation" title="API documentation" v-if="scriptingOptionActivated() && !hideAPIButton" class="mr-2">
    <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          title="API documentation"
        >
          <tooltipApiDocumentation />
        </exo-help-dialog>
    <div style="max-width:1200px; word-break:break-all;">
    <table border="1|0" cellpadding="10" class="table mt-5">
      <thead class="pl-2">
        <th bgcolor="grey" :colspan="numberOfColumns()"> {{ root.getCurrentFormTitle() }} </th>
        <tr>
          <th bgcolor="darkgrey" scope="col"> </th>
          <th bgcolor="darkgrey" :colspan="numberOfColumns()-1">Fields name</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry) in ['required','optional']" >
          <th class="table pl-2 pr-2 black--text" style="min-width:80px" bgcolor="lightgrey" scope="row" v-if="getPropertiesList(entry)!=null && getPropertiesList(entry).length>0">{{ entry }}</th>
          <td  class="table pl-2 pr-2" :colspan="numberOfColumns()-1" v-if="getPropertiesList(entry)!=null && getPropertiesList(entry).length>0">{{ getPropertiesList(entry).join(',&nbsp;') }}</td>
        </tr>
        <tr  v-if="isOneOf()">
          <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" scope="row">Types</th>
          <td class="table pl-2 pr-2" v-for="item in getItemList()"> {{item}}</td>
        </tr>
        <tr v-if="isOneOf()">
          <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" scope="row">Additional required fields</th>
          <td class="table pl-2 pr-2" v-for="(entry, i) in getListOfTypes()" >{{ oneOfAdditionalRequiredOrOptionalField(i,'required') }}</td>
        </tr>
        <tr v-if="isOneOf()">
          <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" scope="row">Additional optional fields</th>
          <td class="table pl-2 pr-2" v-for="(entry, i) in getListOfTypes()" > {{ oneOfAdditionalRequiredOrOptionalField(i,'optional') }}</td>
        </tr>
      </tbody>   
    </table>
    
   <table class="table mt-5" border="1|0">
     <thead>
     <th bgcolor="darkgrey" :colspan="9">  General fields properties (required and optional) </th>
       <tr>
         <th class="table pl-2 pr-2 black--text" style="min-width:85px" bgcolor="lightgrey" scope="col"> Name </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:70px" bgcolor="lightgrey" scope="col"> Type </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:85px" bgcolor="lightgrey" v-if="!isColumnEmpty('min', getAllProperties())" scope="col"> Minimum </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:85px" bgcolor="lightgrey" v-if="!isColumnEmpty('max', getAllProperties())" scope="col"> Maximum </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:85px" bgcolor="lightgrey" v-if="!isColumnEmpty('excluded', getAllProperties())" scope="col"> Excluded value(s) </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:85px" bgcolor="lightgrey" v-if="!isColumnEmpty('default', getAllProperties())" scope="col"> Default value </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:50px" bgcolor="lightgrey" v-if="!isColumnEmpty('unit', getAllProperties())" scope="col"> Unit </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:85px" bgcolor="lightgrey" v-if="enumTypesObjects(getAllProperties())" scope="col"> Possible values (for enum) </th>
         <th class="table pl-2 pr-2 black--text" style="min-width:100px" bgcolor="lightgrey" v-if="enumTypesObjects(getAllProperties())" scope="col"> Implications </th>
       </tr>
     </thead>
     <tbody>
     <tr v-for="entry in getAllProperties()">
     <th class="table pl-2 pr-2" style="min-width:85px" scope="row">{{ getNameAndLabel(entry) }}</th>
     <td class="table pl-2 pr-2" style="min-width:70px" scope="row">{{ getType(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('min', getAllProperties())" scope="row">{{ getMin(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('max', getAllProperties())" scope="row">{{ getMax(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('excluded', getAllProperties())" scope="row">{{ getExcludedValues(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('default', getAllProperties())" scope="row">{{ getDefaultValue(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:50px" v-if="!isColumnEmpty('unit', getAllProperties())" scope="row">{{ getUnit(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="enumTypesObjects(getAllProperties())" scope="row"> {{ getPossibleEnumValues(entry) }} </td>
     <td class="table pl-2 pr-2" style="min-width:85px white-space: pre-line" v-if="enumTypesObjects(getAllProperties())" scope="row"> {{ getGeneralImplications(entry, getEnumValues(entry)) }} </td>
   </tr>
     </tbody>
   </table>
   <div v-if="isOneOf()">
   <div v-for="objectType in getItemList()">
   <table class="table mt-5" border="1|0">
     <thead>
     <th bgcolor="darkgrey" :colspan="9">{{tableTitleOneOf(objectType)}}</th>
       <tr>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" scope="col"> Name </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" scope="col"> Type </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('min', additionalRequirements(objectType))" scope="col"> Minimum </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('max', additionalRequirements(objectType))" scope="col"> Maximum </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('excluded', additionalRequirements(objectType))" scope="col"> Excluded value(s) </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('default', additionalRequirements(objectType))" scope="col"> Default value </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('unit', additionalRequirements(objectType))" scope="col"> Unit </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="enumTypesObjects(additionalRequirements(objectType))" scope="col"> Possible values (for enum) </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="enumTypesObjects(additionalRequirements(objectType))" scope="col"> Implications </th>
       </tr>
     </thead>
     <tbody>
     <tr v-for="(entry, i) in additionalRequirements(objectType)" :key="i">
     <th class="table pl-2 pr-2" style="min-width:85px" scope="row">{{ getNameAndLabel(entry) }}</th>
     <td class="table pl-2 pr-2" style="min-width:70px" scope="row">{{ getType(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('min', additionalRequirements(objectType))" scope="row">{{ getMin(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('max', additionalRequirements(objectType))" scope="row">{{ getMax(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('excluded', additionalRequirements(objectType))" scope="row">{{ getExcludedValues(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('default', additionalRequirements(objectType))" scope="row">{{ getDefaultValue(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:50px" v-if="!isColumnEmpty('unit', additionalRequirements(objectType))" scope="row">{{ getUnit(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="enumTypesObjects(additionalRequirements(objectType))" scope="row"> {{ getPossibleEnumValues(entry) }} </td>
     <td class="table pl-2 pr-2" style="min-width:85px white-space: pre-line" v-if="enumTypesObjects(additionalRequirements(objectType))" scope="row"> {{ getImplications(objectType, entry) }} </td>
   </tr>
     </tbody>
   </table>
   </div>
   </div>

   <div v-if="getListOfFieldsInEnumeratedField().length>0">
   <table class="table mt-5" border="1|0">
     <thead>
     <th bgcolor="darkgrey" :colspan="9"> Remaining field properties </th>
       <tr>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" scope="col"> Name </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" scope="col"> Type </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('min', getListOfFieldsInEnumeratedField())" scope="col"> Minimum </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('max', getListOfFieldsInEnumeratedField())" scope="col"> Maximum </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('excluded', getListOfFieldsInEnumeratedField())" scope="col"> Excluded value(s) </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('default', getListOfFieldsInEnumeratedField())" scope="col"> Default value </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="!isColumnEmpty('unit', getListOfFieldsInEnumeratedField())" scope="col"> Unit </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="enumeratedFieldInEnumeratedField" scope="col"> Possible values (for enum) </th>
         <th class="table pl-2 pr-2 black--text" bgcolor="lightgrey" v-if="enumeratedFieldInEnumeratedField" scope="col"> Implications </th>

       </tr>
     </thead>
     <tbody>
     <tr v-for="entry in getListOfFieldsInEnumeratedField()">
     <th class="table pl-2 pr-2" style="min-width:85px" scope="row">{{ getNameAndLabel(entry) }}</th>
     <td class="table pl-2 pr-2" style="min-width:70px" scope="row">{{ getType(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('min', getListOfFieldsInEnumeratedField())" scope="row">{{ getMin(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('max', getListOfFieldsInEnumeratedField())" scope="row">{{ getMax(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('excluded', getListOfFieldsInEnumeratedField())" scope="row">{{ getExcludedValues(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="!isColumnEmpty('default', getListOfFieldsInEnumeratedField())" scope="row">{{ getDefaultValue(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:50px" v-if="!isColumnEmpty('unit', getListOfFieldsInEnumeratedField())" scope="row">{{ getUnit(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px" v-if="enumeratedFieldInEnumeratedField" scope="row"> {{getPossibleEnumValues(entry) }}</td>
     <td class="table pl-2 pr-2" style="min-width:85px white-space: pre-line" v-if="enumeratedFieldInEnumeratedField" scope="row"> {{ getAdditionalImplications(entry) }}</td>
   </tr>
     </tbody>
   </table>
   </div>
   </div>

     </exo-api-button>
      &nbsp; &nbsp; <i style="color:grey;"><sub>Fields marked with an asterisk (*) are mandatory. </sub>
      
      <sub v-if="root.isAnalyticalMission() === true">Reference objects marked with two asterisks (**) are parametric.</sub></i> 
    </v-card-actions>
  </v-card>
  `
  })

  Vue.component('exo-card-form', {
    props: {
      label: String
    },

    template: `
    <v-card flat>
      <v-row no-gutters>
        <v-col cols="11">
          <v-divider class="m-0 mb-2" ></v-divider>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="p-0">
        <div class="ml-4 mr-4">
          <v-row no-gutters>
            <v-col cols="11">
              <h3 class="blue-grey--text m-0 p-0">
                <span>{{label}}</span>
              </h3>
            </v-col>
            <v-col cols="1">
            <slot name="titleTooltip"></slot>
            </v-col>
          </v-row>
        </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="p-0">
          <div class="ml-4 mr-4">
            <slot></slot> <!-- the fields -->
          </div>
          <br/>
        </v-col>
      </v-row>
    </v-card>
 `
  })

  Vue.component('exo-input-define-orbit', {
    props: {
      root: Object,
      name: String
    },
    template: `
          <v-row no-gutters>
            <v-container class="p-0">
              <v-col class="subheading grey--text darken-1" cols="4">Defined by:</v-col>
              <v-radio-group v-model="root.inputs.definitionType">
                <v-radio
                  v-for="option in root.enumPropertiesList[name]"
                  :key="option.text"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </v-container>
          </v-row>
    `
  })

  // TODO use a mixins for exo-input-ref-notparametric exo-input-ref exo-input-ref-multiple
  Vue.component('exo-input-ref-notparametric', {
    props: {
      root: Object,
      name: String,
      parentObject: {
        type: Object,
        default: null
      },
      type: String,
      componentRoute: String,
      tooltip: String,
      onChangeCallback: {
        type: Function,
        default: function () {}
      },
      multiple: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      alignWithParametricField: {
        type: Boolean,
        default: false
      },
      forceDisplay: {
        type: Boolean,
        default: false
      },
      canCreate: {
        type: Boolean,
        default: true
      },
      canEdit: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        hoverState: false
        // editState: false
      }
    },

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      styleObject() {
        return componentTools.styleObject(this)
      },
      ...mapGetters({
        editedComponentName: 'editedComponentName'
      }),

      rules() {
        const fieldState = this.root.getFieldState(
          this.getParentObject,
          this.name
        )
        const rules = fieldState.value === true ? [] : [fieldState.message]
        return rules
      }
    },
    methods: {
      ...mapActions(['updateEditedComponentName']),
      savePathToComeBack(item) {
        componentTools.setPathToComeBack(this, item)
        //update form when an item is edited or created
        this.getParentObject[this.name] = componentTools.updateExoInput(
          this,
          item
        )
      },

      computeIsolatedPointsOfInterestNames(data) {
        if (data.isolatedPointsOfInterest == null) {
          return ''
        }
        let isolatedPointsOfInterestNames = ''
        for (let i = 0; i < data.isolatedPointsOfInterest.length; i++) {
          isolatedPointsOfInterestNames +=
            data.isolatedPointsOfInterest[i].name +
            ': (' +
            dataTools.formatAngle(
              dataTools.rad2deg(data.isolatedPointsOfInterest[i].longitude)
            ) +
            ', ' +
            dataTools.formatAngle(
              dataTools.rad2deg(data.isolatedPointsOfInterest[i].latitude)
            ) +
            ')'
          isolatedPointsOfInterestNames += ' / '
        }
        return isolatedPointsOfInterestNames.substring(
          0,
          isolatedPointsOfInterestNames.length - 3
        )
      },

      computeearthMeshes(data) {
        if (data.earthMeshes == null) {
          return ''
        }
        let earthMeshes = ''
        for (let i = 0; i < data.earthMeshes.length; i++) {
          earthMeshes += data.earthMeshes[i].name + ' / '
        }
        return earthMeshes.substring(0, earthMeshes.length - 3)
      },

      getZoneOfInterestInfos(item) {
        let infos = ''
        if (
          item.isolatedPointsOfInterest != null &&
          item.isolatedPointsOfInterest?.length > 0
        ) {
          infos +=
            item.isolatedPointsOfInterest.length == 1
              ? 'Isolated point of interest: '
              : 'Isolated points of interest: '
          infos += this.computeIsolatedPointsOfInterestNames(item) + '\n'
        }
        if (item.earthMeshes != null && item.earthMeshes?.length > 0) {
          infos +=
            item.earthMeshes.length == 1 ? 'Earth mesh: ' : 'Earth meshes: '
          infos += this.computeearthMeshes(item) + '\n'
        }
        return infos
      },

      getConstellationInfos(item, root) {
        const numberOfGeometries =
          item.homogeneousConstellationGeometries.length
        let infos = `${numberOfGeometries} ${
          numberOfGeometries === 1 ? ' geometry' : ' geometries'
        } selected \n`
        for (let i = 0; i < numberOfGeometries; i++) {
          const currentItem = item.homogeneousConstellationGeometries[i]
          if (currentItem) {
            infos +=
              (numberOfGeometries === 1
                ? ''
                : this.getRightNumberToDisplay(i + 1)) +
              'Geometry : ' +
              currentItem.displayedName +
              '\n'
            infos +=
              root.getInfos(currentItem) +
              (i < numberOfGeometries - 1 ? '\n' : '')
          }
        }
        return infos
      },

      getRightNumberToDisplay(number) {
        switch (number) {
          case 0:
            return 'No '
          case 1:
            return '1st '
          case 2:
            return '2nd '
          case 3:
            return '3rd '
          default:
            return `${number}th `
        }
      }
    },
    template: `
    <v-row no-gutters v-if="root.isRequiredOrOptional(name, getParentObject) || forceDisplay">
      <v-tooltip right :disabled="!(tooltip !== '' && tooltip != null)">
        <template v-slot:activator="scope">
          <v-select
            :disabled="disabled"
            v-on:keyup.enter="$event.stopPropagation()"
            :label="root.getFormLabel(name)"
            v-on:input="onChangeCallback"
            v-on="scope.on"
            :multiple="multiple"
            :items="root[type + 'sNotParametrics']"
            v-model="getParentObject[name]"
            :menu-props="{transition:'scale-transition'}"
            :rules="rules"
            >
            <template v-slot:item="{ item, index }">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-row justify="center" align="center" no-gutters>
                  <v-col v-on="on"
                      @mouseover="item.editState = true"
                      @mouseout="item.editState = false"
                      class="d-inline-flex">
                      <v-row justify="center" align="center">
                        <v-col class="ma-0 pa-0" cols="10">
                          <span>{{ item.text }}</span>
                        </v-col>
                        <v-col v-if="canEdit === true" class="ma-0 pa-0" cols="1">
                          <div class="text-right">
                            <v-btn
                              icon
                              :style="item.editState ? { display: 'inline-block'} : { display: 'none'}"
                              @click="savePathToComeBack(item)">
                              <v-icon size="20" color="primary">edit</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
                <span v-if="item.value.typeName == 'ZoneOfInterestDefinition'" style="margin: 0; padding: 0; white-space: pre-line">
                  {{getZoneOfInterestInfos(item.value)}}
                </span>
                <span v-else-if="item.value.typeName == 'ConstellationDefinition'" style="margin: 0; padding: 0; white-space: pre-line">
                  {{getConstellationInfos(item.value,root)}}
                </span>
                <span v-else style="margin: 0; padding: 0; white-space: pre-line">
                  {{root.getInfos(item.value)}}
                </span>
              </v-tooltip>
            </template>
            <template v-if="canCreate === true" v-slot:append-item>
              <v-row column wrap
                @mouseover="hoverState = true"
                @mouseout="hoverState = false"
                @click="savePathToComeBack()"
                style="cursor: pointer">
                <v-divider class="m-0"></v-divider>
    
                <v-list-item disabled :style="styleObject">
                  <v-list-item-avatar>
                    <v-icon color="grey lighten-1">add</v-icon>
                  </v-list-item-avatar>
    
                  <v-list-item-content>
                  <v-list-item-title>Create new {{root.getLabel(name).toLowerCase()}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-row>
            </template>
          </v-select>
          <v-col cols="1">
            <slot></slot>
          </v-col>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
      <v-col v-if="alignWithParametricField" cols="2"/>
    </v-row>
  
  `
  })

  Vue.component('exo-modal-references', {
    props: ['root', 'modalContent'],

    template: `
  <v-dialog
    v-model="root.showModal"
    width="500"
    fluid
    id="modalRef"
    ref="modalRef"
  >
    <v-card>
      <v-card-title :style="backgroundStarStyle">
        <v-row no-gutters>
          <v-col cols="1" offset="11">
            <v-btn icon v-on:click="callbackHide()">
              <v-icon color="black">close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <label v-if="modalContent.item">
          <strong>
            {{ modalContent.content.name }} '{{ modalContent.item.name }}'
          </strong>
          is used by the following objects.
          You will have to update them manually. Are you sure you want to delete it ?
        </label>
        <ul>
          <exo-nested-references v-for="(child, key) in modalContent.content" :key="key"
            :root="root"
            :item="child"
            @make-folder="makeFolder"
          >
          </exo-nested-references>
        </ul>
      </v-card-text>
      <v-row no-gutters>
        <v-col cols="7"/>
        <v-col cols="4" class="mb-2 ml-8">
          <v-btn small class="white--text" color="grey darken-3" v-on:click="callbackHide()">Cancel</v-btn>
          <v-btn small class="white--text" color="grey darken-3" v-on:click="remove(modalContent.item, modalContent.item.typeName, $event)">Confirm</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>`,

    computed: {
      backgroundStarStyle() {
        return 'background: #3BE287'
      }
    },

    methods: {
      remove(item, itemType, button) {
        let objectName = item.name
        this.root.$http
          .delete(this.root.getAPI(itemType).toLowerCase() + 's/' + item.id)
          .then((responseDelete) => {
            this.root.$root.$emit('base-object-updated')
            this.root.successAlertDisplayed = true
            this.root.successAlertMessage = objectName + ' deleted'
            this.root.refreshTable()
            this.callbackHide()
          })
          .catch((e) => {
            this.root.displayMessage(
              'Error deleting ' + objectName + '. ',
              e,
              'notification',
              'error'
            )
            this.root.refreshTable()
          })
      },

      makeFolder(item) {
        Vue.set(item, 'references', [])
        this.$emit('make-folder', this.item)
      },

      callbackHide() {
        this.root.showModal = false
      }
    }
  })

  Vue.component('exo-help-dialog', {
    props: {
      root: Object,
      color: {
        type: String,
        default: 'grey--text lighten-4'
      },
      margin: {
        type: String,
        default: 'mt-6 ml-2'
      },
      width: {
        type: String,
        default: '700'
      },
      iconScale: {
        type: String,
        default: '1.1'
      },
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dialog: false
      }
    },
    computed: {
      backgroundStarStyle() {
        return 'background: #3BE287'
      }
    },

    template: `
  <v-dialog :width="width" v-model="dialog">
    <template v-slot:activator="{ on: menu }">
      <v-row justify="end" no-gutters>
        <v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-row no-gutters align="center" :class="margin">
              <v-col>
                <v-btn icon small v-on="{ ...tooltip, ...menu }">
                  <icon :scale="iconScale" :class="color" name="question-circle"/>
                </v-btn>
                </v-col>
                </v-row>
            </template>
            <span>{{title}}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </template>

    <v-card>
       <v-card>
        <v-card-title :style="backgroundStarStyle">
        <span class="headline black--text"> {{title}}</span>
        <v-spacer></v-spacer>
        <v-btn icon small class="m-0" light @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
        <div class="mt-3">
        <slot></slot>
        </div>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
    `
  })

  Vue.component('exo-api-button', {
    props: {
      root: Object,
      margin: {
        type: String,
        default: 'mt-6 ml-2'
      },
      width: {
        type: String,
        default: '1200'
      },
      buttonName: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dialog: false
      }
    },
    computed: {
      backgroundStarStyle() {
        return 'background: #3BE287; colour: black'
      }
    },

    template: `
    <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
      <v-btn :disabled="disabled" v-on="on" @click="dialog = true" type="button" color="indigo" outlined ><span>{{ buttonName }}</span>
      </v-btn>
      </template>
      <span>{{ title }}</span>
    </v-tooltip>
    <v-dialog :eager="true" :width="width" v-model="dialog" scrollable>
      <v-card>
        <v-card-title :style="backgroundStarStyle">
          <span class="headline black--text"> {{ title }}</span>
          <v-spacer></v-spacer>
          <v-btn icon small class="m-0" light @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="dialog-content mt-4">
        <slot></slot>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
    `
  })

  Vue.component('exo-export-constellation-dialog', {
    props: {
      dashboard: Object
    },

    methods: {
      getTabulatedData(meshIndex) {
        const dataResultType = []
        const meshPerformance =
          this.dashboard.currentResultsLog.results.meshPerformances[meshIndex]
        for (const point of meshPerformance.points) {
          const pointData = {
            latitude: point.geographicPoint.lat,
            longitude: point.geographicPoint.lon
          }
          for (const category in this.tabulatedTypeExport) {
            const results = {}
            for (const type of this.tabulatedTypeExport[category]) {
              results[type] = this.dashboard.getAppliedMetricValue(point, type)
            }
            pointData[category] = results
          }
          dataResultType.push(pointData)
        }
        return dataResultType
      },
      initTypeChoice() {
        this.dashboard.mapCategories.forEach((category) => {
          var typesSelected = {
            all: false
          }
          this.availableMapTypes(category).forEach((type) => {
            typesSelected[type] = false
          })
          Vue.set(this.typeChoice, category, typesSelected)
        })
      },
      checkAll(category) {
        const checked = this.typeChoice[category]['all']
        for (let type in this.typeChoice[category]) {
          if (type !== 'all') {
            this.typeChoice[category][type] = checked
          }
        }
      },
      updateCheckAllStatus(category) {
        let allChecked = true
        for (let type in this.typeChoice[category]) {
          if (type !== 'all') {
            allChecked = allChecked && this.typeChoice[category][type]
          }
        }
        this.typeChoice[category]['all'] = allChecked
      },
      availableMapTypes(map) {
        return this.dashboard.mapTypes.filter((el) => el.startsWith(map))
      },

      getMatrixHeader(longitudes, csvMatrix) {
        if (this.matrixResultFormat === 'Raw') {
          let unit =
            this.dashboard.unitTypes[
              this.dashboard.appliedDashboardConfiguration.currentMap
            ]
          if (unit == null || unit === '') {
            unit = ''
          } else {
            unit = ' (' + unit + ')'
          }
          csvMatrix = 'Result format : Raw' + unit + ';'
        } else {
          csvMatrix = 'Result format : Human readable;'
        }
        if (this.matrixLongitudeFormat.length === 1) {
          if (this.matrixLongitudeFormat[0] === 'Raw (rad)') {
            csvMatrix += 'Raw (rad);'
            longitudes.forEach((lon) => {
              csvMatrix += lon + ';'
            })
          } else {
            csvMatrix += 'Human readable;'
            longitudes.forEach((lon) => {
              csvMatrix +=
                dataTools.formatAngle(
                  dataTools.convertUnits(lon, 'rad', 'deg')
                ) + ';'
            })
          }
        } else {
          csvMatrix += 'Raw (rad);'
          longitudes.forEach((lon) => {
            csvMatrix += lon + ';'
          })
          csvMatrix += '\n;Human readable;'
          longitudes.forEach((lon) => {
            csvMatrix +=
              dataTools.formatAngle(dataTools.convertUnits(lon, 'rad', 'deg')) +
              ';'
          })
        }
        csvMatrix += '\n'
        if (this.matrixLatitudeFormat.length === 1) {
          if (this.matrixLatitudeFormat[0] === 'Raw (rad)') {
            csvMatrix += 'Raw (rad)\n'
          } else {
            csvMatrix += 'Human readable\n'
          }
        } else {
          csvMatrix += 'Raw (rad);Human readable\n'
        }
        return csvMatrix
      },
      getMatrixResults(meshIndex, longitudes, latitudes, csvMatrix) {
        latitudes.forEach((lat, latIndex) => {
          if (this.matrixLatitudeFormat.length === 2) {
            csvMatrix +=
              lat +
              ';' +
              dataTools.formatAngle(dataTools.convertUnits(lat, 'rad', 'deg')) +
              ';'
          } else if (this.matrixLatitudeFormat[0] === 'Raw (rad)') {
            csvMatrix += lat + ';;'
          } else {
            csvMatrix +=
              dataTools.formatAngle(dataTools.convertUnits(lat, 'rad', 'deg')) +
              ';;'
          }
          longitudes.forEach((lon, lonIndex) => {
            let val =
              this.dashboard.currentData[meshIndex].z[latIndex][lonIndex]
            if (val == null) {
              val = ''
            }
            if (this.matrixResultFormat === 'Raw') {
              csvMatrix += val + ';'
            } else {
              csvMatrix += this.dashboard.valueToUnitText(val) + ';'
            }
          })
          csvMatrix += '\n'
        })
        return csvMatrix
      },
      getTabulatedHeader() {
        let csvTabulated
        if (this.axisFormat.length === 1) {
          if (this.axisFormat[0] === 'Raw (rad)') {
            csvTabulated = 'Latitude Raw (rad);Longitude Raw (rad);'
          } else {
            csvTabulated = 'Latitude Human readable;Longitude Human readable;'
          }
        } else {
          csvTabulated =
            'Latitude Raw (rad);Latitude Human readable;Longitude Raw (rad);Longitude Human readable;'
        }
        for (let categories in this.tabulatedTypeExport) {
          for (let types of this.tabulatedTypeExport[categories]) {
            if (this.resultsFormat.length === 1) {
              if (this.resultsFormat[0] === 'Raw (rad)') {
                let unit = this.unitTypes[types]
                if (unit == null || unit === '') {
                  unit = ''
                } else {
                  unit = ' (' + unit + ')'
                }
                csvTabulated +=
                  this.dashboard.getResultsFieldLabel(categories) +
                  ' ' +
                  this.dashboard.getResultsFieldLabel(types) +
                  ' Raw ' +
                  unit +
                  ';'
              } else {
                csvTabulated +=
                  this.dashboard.getResultsFieldLabel(categories) +
                  ' ' +
                  this.dashboard.getResultsFieldLabel(types) +
                  ' Human readable;'
              }
            } else {
              let unit = this.dashboard.unitTypes[types]
              if (unit == null || unit === '') {
                unit = ''
              } else {
                unit = ' (' + unit + ')'
              }
              csvTabulated +=
                this.dashboard.getResultsFieldLabel(categories) +
                ' ' +
                this.dashboard.getResultsFieldLabel(types) +
                ' Raw ' +
                unit +
                ';' +
                this.dashboard.getResultsFieldLabel(categories) +
                ' ' +
                this.dashboard.getResultsFieldLabel(types) +
                ' Human readable;'
            }
          }
        }
        csvTabulated += '\n'
        return csvTabulated
      },
      getTabulatedResults(meshIndex, csvTabulated) {
        const self = this
        let data = this.getTabulatedData(meshIndex)
        data.forEach((point) => {
          if (self.axisFormat.length === 2) {
            csvTabulated +=
              point.longitude +
              ';' +
              dataTools.formatAngle(
                dataTools.convertUnits(point.longitude, 'rad', 'deg')
              ) +
              ';' +
              point.latitude +
              ';' +
              dataTools.formatAngle(
                dataTools.convertUnits(point.latitude, 'rad', 'deg')
              ) +
              ';'
          } else if (self.axisFormat[0] === 'Raw (rad)') {
            csvTabulated += point.longitude + ';' + point.latitude + ';'
          } else {
            csvTabulated +=
              dataTools.formatAngle(
                dataTools.convertUnits(point.longitude, 'rad', 'deg')
              ) +
              ';' +
              dataTools.formatAngle(
                dataTools.convertUnits(point.latitude, 'rad', 'deg')
              ) +
              ';'
          }
          for (let category in self.tabulatedTypeExport) {
            for (let type of self.tabulatedTypeExport[category]) {
              if (self.resultsFormat.length === 2) {
                csvTabulated +=
                  point[category][type] +
                  ';' +
                  self.dashboard.valueToUnitTextFromType(
                    point[category][type],
                    type
                  ) +
                  ';'
              } else if (self.resultsFormat === 'Raw') {
                csvTabulated += point[category][type] + ';'
              } else {
                csvTabulated +=
                  self.dashboard.valueToUnitTextFromType(
                    point[category][type],
                    type
                  ) + ';'
              }
            }
          }
          csvTabulated += '\n'
        })
        return csvTabulated
      },
      exportData() {
        if (this.exportType != null) {
          for (const meshIndex in this.dashboard.currentResultsLog.results
            .meshPerformances) {
            const meshName =
              this.dashboard.currentResultsLog.results.earthMeshes[meshIndex]
                .name
            const longitudes =
              this.dashboard.currentResultsLog.results.earthMeshes[meshIndex]
                .longitudes
            const latitudes =
              this.dashboard.currentResultsLog.results.earthMeshes[
                meshIndex
              ].latitudes.reverse()
            if (this.exportType === 'tabulated') {
              let csvTabulated = this.getTabulatedHeader()
              csvTabulated = this.getTabulatedResults(meshIndex, csvTabulated)
              dataTools.downloadFile(
                this.dashboard.currentMission.name + '_' + meshName,
                csvTabulated
              )
            } else if (this.exportType === 'matrix') {
              const currentMap =
                this.dashboard.appliedDashboardConfiguration.currentMap
              const fieldName = this.dashboard.getResultsFieldLabel(currentMap)
              let csvMatrix = ';'
              if (this.matrixLatitudeFormat.length === 2) {
                csvMatrix += ';'
              }
              csvMatrix = this.getMatrixHeader(longitudes, csvMatrix)
              csvMatrix = this.getMatrixResults(
                meshIndex,
                longitudes,
                latitudes,
                csvMatrix
              )
              dataTools.downloadFile(fieldName + '_' + meshName, csvMatrix)
            }
          }
        }
      }
    },
    computed: {
      tabulatedTypeExport() {
        var listCategoriesTypeChoice = {}
        for (let categorie in this.typeChoice) {
          var typeList = []
          for (let type in this.typeChoice[categorie]) {
            if (this.typeChoice[categorie][type] === true && type !== 'all') {
              typeList.push(type)
            }
          }
          if (typeList.length) {
            listCategoriesTypeChoice[categorie] = typeList
          }
        }
        return listCategoriesTypeChoice
      },
      exportEnable() {
        return (
          this.axisFormat.length > 0 &&
          this.resultsFormat.length > 0 &&
          Object.entries(this.tabulatedTypeExport).length
        )
      }
    },
    data() {
      return {
        axis: ['Human readable', 'Raw (rad)'],
        result: ['Human readable', 'Raw'],
        items: [
          { value: 'matrix', text: 'Current results as matrix' },
          { value: 'tabulated', text: 'Tabulated results' }
        ],
        axisFormat: ['Human readable'],
        resultsFormat: ['Human readable'],
        exportType: null,
        typeChoice: {},
        matrixLongitudeFormat: ['Human readable'],
        matrixLatitudeFormat: ['Human readable'],
        matrixResultFormat: 'Human readable'
      }
    },
    mounted() {
      this.initTypeChoice()
    },
    template: `
    <v-card>
      <v-card-title class="pb-0">
        <v-row align-center>
          <v-col>
            <v-row>
             <icon scale="1.5" class="blue--text lighten-4" name="download"/>
              <v-toolbar-title class="grey--text title">Export Result</v-toolbar-title>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-col>
      <v-select
      v-model="exportType"
      class="grey--text pt-4 ml-2 mr-2"
      :items="items"
      label="Export type"
      ></v-select>
    </v-col>
      <div v-if="exportType === 'matrix'">
        <v-row align-center>
          <v-col cols="4">
            <span class="title font-weight-regular full-width ml-3">Longitude</span>
          </v-col>
          <v-col cols="7" offset-md-1>
            <v-select multiple v-model="matrixLongitudeFormat" class="mr-4" :items="axis" />
          </v-col>
        </v-row>
        <v-row align-center>
          <v-col cols="4" >
            <span class="title font-weight-regular ml-3">Latitude</span>
          </v-col>
          <v-col cols="7" offset-md-1>
            <v-select multiple v-model="matrixLatitudeFormat" class="mr-4" :items="axis" />
          </v-col>
        </v-row>
        <v-row align-center>
          <v-col cols="4">
            <span class="title font-weight-regular ml-3">Result</span>
          </v-col>
          <v-col cols="7" offset-md-1>
            <v-select v-model="matrixResultFormat" class="mr-4" :items="result" />
          </v-col>
        </v-row>
      </div>
      <div v-if="exportType === 'tabulated'">
        <v-row v-for="category in dashboard.mapCategories" :key="category">
          <v-col>
            <v-row class="mt-3 ml-2" style="height: 50px;">
              <v-col>
              <span class="subtitle-1">{{dashboard.getResultsFieldLabel(category)}}</span>
              </v-col>
              <v-col class=" ml-2" align-self-center shrink v-if="availableMapTypes(category).length > 1">
                <v-checkbox class="ml-n3 mt-n1" v-on:change="checkAll(category)" v-model="typeChoice[category]['all']" :name="category" />
              </v-col>
            </v-row>
            <v-row
              align-center
              style="height: 30px;"
              v-for="type in availableMapTypes(category)"
              :key="type"
            >
              <v-col grow>
                <span class="subtitle-2 grey--text ml-5">{{ dashboard.getResultsFieldLabel(type) }}</span>
              </v-col>
              <v-col shrink>
                <v-checkbox class="mt-n1" v-on:change="updateCheckAllStatus(category)" v-model="typeChoice[category][type]" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="m-0"></v-divider>
        <v-row class="mt-2">
          <v-col cols="6" class="ml-2 mr-2">
            <v-select multiple label="Axis format" :items="axis" v-model="axisFormat"/>
            </v-col>
          <v-col cols="6" class="ml-2 mr-2">
            <v-select multiple label="Result format" :items="result" v-model="resultsFormat"/>
          </v-col>
        </v-row>
      </div>
      <div v-if="exportType">
          <v-col>
            <v-row class="mt-1" justify-end>
              <v-btn color="primary" :disabled="!exportEnable && exportType === 'tabulated'" @click="exportData()" >Export</v-btn>
            </v-row>
          </v-col>
      </div>
    </v-card>
    `
  })

  Vue.component('exo-form-alert', {
    props: {
      type: {
        type: String,
        default: 'error' // warning accepted
      }
    },
    template: `
      <div :class="'v-messages theme--light ' + type + '--text'">
      <slot></slot>
      </div>
    `
  })

  Vue.component('exo-input-slider', {
    props: {
      root: Object,
      tooltip: String,
      name: String,
      max: Number,
      alignWithParametricField: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      onChangeCallback: {
        type: Function
      },
      min: {
        type: Number,
        default: 1
      },
      step: {
        type: Number,
        default: 1
      }
    },
    computed: {
      nbCols() {
        return componentTools.nbCols(this)
      }
    },

    template: `
    <v-row no-gutters>
      <v-col>
        <v-tooltip top :disabled="!(tooltip !== '' && tooltip != null)" nudge-bottom="20" max-width="300px">
          <template v-slot:activator="{ on }">
            <v-row no-gutters v-on="on">
              <v-col :cols="nbCols">
                <v-slider
                  class="pr-2"
                  v-model="root.inputs[name]"
                  thumb-label="always"
                  thumb-size="30"
                  :disabled="root.getMaxDutyCycle === 0"
                  :readonly="disabled"
                  :max="Math.floor(max)"
                  :min="Math.ceil(min)"
                  :step="step"
                  :label="root.getFormLabel(name) + root.getDefaultUnitLabel(name)"
                  v-on:input="onChangeCallback"
                ></v-slider>
              </v-col>
              <v-col cols="1">
                <slot></slot>
              </v-col>
              <v-col v-if="alignWithParametricField" cols="2"></v-col>
            </v-row>
          </template>
          <span>{{tooltip}}</span>
        </v-tooltip>
      </v-col>
    </v-row>
`
  })

  Vue.component('exo-input-date-time', {
    props: {
      forceDisplay: {
        type: Boolean,
        default: false
      },
      forcedLabel: {
        type: String,
        default: null
      },
      root: Object,
      name: String,
      parentObject: {
        type: Object,
        default: null
      },
      datePickerProps: {
        type: Object,
        default: () => {}
      }
    },

    components: {
      exoDatetimePicker
    },

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      display() {
        return (
          this.forceDisplay ||
          this.root?.isRequiredOrOptional(this.name, this.getParentObject)
        )
      },
      getLabel() {
        if (this.forcedLabel != null) {
          return this.forcedLabel
        } else {
          return this.root.getFormLabel(this.name)
        }
      }
    },

    methods: {
      updateValue(value) {
        this.getParentObject[this.name] = value
      }
    },

    template: `
    <v-row no-gutters v-if="display">
      <exoDatetimePicker
        outlined
        class="mt-3"
        dense
        :label="getLabel"
        v-model="getParentObject[name]"
        :datePickerProps="datePickerProps"
        @input="updateValue"
        >
      </exoDatetimePicker>
      <v-col cols="1">
      <slot></slot>
      </v-col>
    </v-row>
  `
  })

  Vue.component('exo-input-string', {
    props: {
      root: Object,
      tooltip: String,
      name: String,
      parentObject: {
        type: Object,
        default: null
      },
      onChangeCallback: {
        type: Function
      }
    },
    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      }
    },

    template: `
              <v-row no-gutters v-if="root.isRequiredOrOptional(name, getParentObject)">
                <v-tooltip right :disabled="!(tooltip !== '' && tooltip != null)">
                  <template v-slot:activator="{ on }">
                    <v-text-field horizontal
                              :label="root.getFormLabel(name) + root.getDefaultUnitLabel(name)"
                              v-on:input="onChangeCallback"
                              v-model="getParentObject[name]"
                              v-on="on"
                              maxlength="100"
                              >
                    </v-text-field>
                    <v-col cols="1">
                    <slot></slot>
                    </v-col>
                  </template>
                  <span>{{tooltip}}</span>
                </v-tooltip>
              </v-row>
    `
  })

  Vue.component('exo-input-doubleArray', {
    props: {
      root: Object,
      tooltip: String,
      name: String,
      parentObject: {
        type: Object,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      valuesToParse: {
        get() {
          let stringToDisplay = ''
          let valuesArray = this.getParentObject[this.name]
          if (!Array.isArray(valuesArray) || !valuesArray.length) {
            return ''
          }
          for (let value of valuesArray) {
            let valueInDegres = dataTools.removeApproximationDigits(
              dataTools.rad2deg(value)
            )
            stringToDisplay += valueInDegres + ';'
          }
          stringToDisplay = stringToDisplay.substring(
            0,
            stringToDisplay.length - 1
          )
          return stringToDisplay
        },
        set(newValue) {
          let array = newValue.split(';')

          let parsedValues = []
          for (let str of array) {
            if (str !== '') {
              let isNegative = /^\d*\.?\d*$/.test(str)
              let number = parseFloat(str)
              let numberInRadians = dataTools.deg2rad(number)
              parsedValues.push(numberInRadians)
            }
          }
          this.getParentObject[this.name] = parsedValues
        }
      }
    },
    // TODO MKF rules :                   :rules="[root.getFieldState(getParentObject, name).rangeField.message]"
    // :rules="[root.getFieldState(getParentObject, name).message]"
    template: `
              <v-row no-gutters v-if="root.isRequiredOrOptional(name, getParentObject)">
                <v-tooltip right :disabled="!(tooltip !== '' && tooltip != null)">
                  <template v-slot:activator="{ on }">
                  <v-text-field horizontal
                              :label="root.getFormLabel(name)"
                              v-model="valuesToParse"
                              placeholder="-30;45;75"
                              v-on="on"
                              :disabled="disabled"
                  >
                </v-text-field>
                    <v-col cols="1">
                    <slot></slot>
                    </v-col>
                  </template>
                  <span>{{tooltip}}</span>
                </v-tooltip>
              </v-row>
    `
  })

  Vue.component('exo-input-double', {
    props: {
      root: Object,
      tooltip: String,
      name: String,
      onChangeCallback: {
        type: Function
      },
      parentObject: {
        type: Object,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      }
    },

    template: `
              <v-row no-gutters v-if="root.isRequiredOrOptional(name, getParentObject)">
                <v-tooltip right :disabled="!(tooltip !== '' && tooltip != null)">
                  <template v-slot:activator="{ on }">
                    <v-text-field horizontal
                              :label="root.getFormLabel(name) + root.getDefaultUnitLabel(name)"
                              v-on:input="onChangeCallback"
                              v-model="getParentObject[name]"
                              v-on="on"
                              :disabled="disabled"
                              :rules="[root.getFieldState(getParentObject, name).message]"
                              >
                    </v-text-field>
                    <v-col cols="1">
                    <slot></slot>
                    </v-col>
                  </template>
                  <span>{{tooltip}}</span>
                </v-tooltip>
              </v-row>
    `
  })

  Vue.component('exo-input-ref-multiple', {
    props: {
      root: Object,
      name: String,
      isParametric: Boolean,
      parentObject: {
        type: Object,
        default: null
      },
      type: String,
      componentRoute: String,
      notEmpty: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        hoverState: false,
        editState: false
      }
    },

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      styleObject() {
        return componentTools.styleObject(this)
      },
      ...mapGetters({
        editedComponentName: 'editedComponentName'
      }),
      parametricName() {
        if (!this.isParametric) {
          return 'sNotParametrics'
        }
        return 's'
      },
      customRules() {
        const rules = []
        if (this.notEmpty) {
          rules.push((value) =>
            value != null && value.length > 0
              ? true
              : 'Please select at least one item.'
          )
        }
        return rules
      }
    },
    methods: {
      ...mapActions(['updateEditedComponentName']),
      savePathToComeBack(item) {
        componentTools.setPathToComeBack(this, item)
        this.getParentObject[this.name] = componentTools.updateExoInputMultiple(
          this,
          item
        )
      }
    },

    template: `
    <v-row no-gutters v-if="root.isRequiredOrOptional(name, getParentObject)">
        <v-col cols="11">
          <v-select 
            v-on:keyup.enter="$event.stopPropagation()"
            v-model="getParentObject[name]"
            :items="root[type + parametricName]"
            :menu-props="{transition:'scale-transition'}" 
            :label="root.getFormLabel(name)"
            multiple
            :rules="customRules"
          > <!-- warning : do not use chips as it is not working with list of objects (need primitive type) -->
          <template v-slot:item="{ item, attrs }">
              
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-row no-gutters
                        @mouseover="item.editState = true"
                        @mouseout="item.editState = false"
                        v-on="on"
                      >
                        <v-col cols="11" class="d-inline-flex ma-0 pa-0">
                            <v-checkbox v-model="attrs.inputValue"/>
                            <span class="mt-5 text--left">{{ item.text }}</span>
                        </v-col>
                        <v-col cols="1" class="ma-0 pa-0" justify="end">
                            <div>
                              <v-btn
                                icon
                                class="mt-3"
                                :style="item.editState ? { display: 'inline-block'} : { display: 'none'}"
                                @click="savePathToComeBack(item)">
                                <v-icon size="20" color="primary">edit</v-icon>
                              </v-btn>
                            </div>
                        </v-col>
                      </v-row>
                    </template>
                    <span style="margin: 0; padding: 0; white-space: pre-line" >{{  root.getInfos(item.value) }}</span>
                  </v-tooltip>
                </template>
                
                <template v-slot:append-item>
                 <v-row column wrap
                    @mouseover="hoverState = true"
                    @mouseout="hoverState = false"
                    @click="savePathToComeBack()"
                    style="cursor: pointer">
                  <v-divider class="m-0"></v-divider>

                  <v-list-item disabled :style="styleObject">
                    <v-list-item-avatar>
                      <v-icon color="grey lighten-1">add</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>Create new {{root.getFormLabel(name).toLowerCase()}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  </v-row>
                </template>

          </v-select>
        </v-col>
        <v-col cols="1">
           <slot></slot>
        </v-col>
    </v-row>
  `
  })

  Vue.component('exo-input-string-array', {
    props: {
      root: Object,
      tooltip: String,
      name: String,
      parentObject: {
        type: Object,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      regExp: {
        type: RegExp
      },
      delimiter: {
        type: String
      }
    },
    data() {
      return { invalidText: null }
    },
    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      valuesToParse: {
        get() {
          let valuesArray = this.getParentObject[this.name]

          if (this.invalidText == null) {
            return valuesArray.join(this.delimiter) + ' '
          } else {
            return this.invalidText
          }
        },
        set(newValue) {
          const parsedStrings = this.parseStrings(newValue)
          if (parsedStrings != null) {
            this.invalidText = null
            this.root.inputs = {
              ...this.root.inputs,
              [this.name]: parsedStrings
            }
          } else {
            this.invalidText = newValue
          }
        }
      },
      errorMessage() {
        return this.invalidText == null ? [] : ['The input is not valid.']
      }
    },
    methods: {
      parseStrings(string) {
        const stringWithoutSpace = string.replace(/,\s/g, '')
        const stringSplited = string.split(this.delimiter)
        let newString = ''
        let arrayStrings = []
        stringSplited.forEach((string) => {
          const matches = [...string.matchAll(this.regExp)]
          matches.forEach((match) => {
            newString += match[0]
            arrayStrings.push(match[1])
          })
        })
        arrayStrings = [...new Set(arrayStrings)]

        if (newString.length == stringWithoutSpace.length) {
          return arrayStrings
        } else {
          return null
        }
      }
    },
    template: `
              <v-row no-gutters v-if="root.isRequiredOrOptional(name, getParentObject)">
                <v-tooltip right :disabled="!(tooltip !== '' && tooltip != null)">
                  <template v-slot:activator="{ on }">
                  <v-text-field
                  :label="root.getFormLabel(name)"
      v-model="valuesToParse"
      :disabled="disabled"
      :error-messages="errorMessage"
      v-on="on"
    ></v-text-field>

                    <v-col cols="1">
                    <slot></slot>
                    </v-col>
                  </template>
                  <span>{{tooltip}}</span>
                </v-tooltip>
              </v-row>
    `
  })
}
